// ============================================================
// ReportRemittance01 — รายงานการจัดเก็บประจำวัน
// ------------------------------------------------------------
// สร้างเอกสาร PDF ด้วย pdfmake แล้วเปิดในแท็บใหม่ด้วย openPdf()
// ตั้งค่า pdfmake + ฟอนต์ไทย อยู่ที่ documents/pdf.js (ใช้ร่วมกันทุกไฟล์ในโฟลเดอร์นี้)
// ============================================================

import { openPdf } from "../pdf.js";
import { total, toFixed, format_date, getStorage, replaceText } from "../../shared/index.js";

import "../../assets/css/bootstrap.css";
import "../../shared/config/global.js";

// พิมพ์รายงานจัดเก็บประจำวัน
async function report_remittance_1(data, start_date) {
  // สร้างฟังก์ชัน Helper เพื่อลดการเขียน Ternary เช็คค่าซ้ำๆ
  const txt = (val) => val ? toFixed(val) : "0.00";
  // แมปประเภทการจ่ายเงินด้วย Array Index แทนการเขียน if-else ยาวๆ
  const paymentLabels = ["-", "บัญชีค่าน้ำ และส่วนกลาง", "โอนเงินเข้าบัญชีนิติ", "เงินกองทุน"];

  // ใช้ .map() แทน for loop เพื่อสร้าง Array ทันที
  const array = data.map((item) => {
    const otherSum = (item.other_income || 0) + (item.fire_cost || 0) + (item.cable_cost || 0);
    // NOTE add_debt/reduce_debt ผ่าน processBillData มาแล้ว รวม add_on_* ไว้ในตัวเอง — บวกซ้ำจะได้ 2 เท่า
    // (แถว "รวมเป็นเงิน" ด้านล่างใช้ t("add_debt") - t("reduce_debt") อยู่แล้ว ต้องให้สูตรตรงกัน)
    const debtSum = (item.add_debt || 0) - (item.reduce_debt || 0);

    return [
      { text: item.first_iw_number || "-", alignment: "center" },
      { text: item.last_iw_number || "-", alignment: "center" },
      { text: item.rw_number || "-", alignment: "center" },
      { text: item.close_job_date ? format_date(item.close_job_date, "dd/mm/yyyy") : "-", alignment: "center" },
      { text: txt(item.water_bill), alignment: "center" },
      { text: txt(item.equipment_maintenance_fee), alignment: "center" },
      { text: txt(item.common_expenses), alignment: "center" },
      { text: txt(item.waste_cost), alignment: "center" },
      { text: txt(otherSum), alignment: "center" },
      { text: txt(debtSum), alignment: "center" },
      { text: txt(item.meter_connect_cost), alignment: "center" },
      { text: txt(item.late_payment), alignment: "center" },
      { text: txt(item.change_satang), alignment: "center" },
      { text: txt(
item.water_bill+
item.equipment_maintenance_fee+
item.common_expenses+
item.waste_cost+
item.cable_cost+
item.other_income+
item.fire_cost+
item.meter_connect_cost+
item.late_payment+
item.change_satang+
debtSum
                          ), alignment: "center" },
      { text: "-", alignment: "center" },
      { text: item.deposit_date ? format_date(item.deposit_date, "dd/mm/yyyy") : "-", alignment: "center" },
      { text: paymentLabels[item.payment_type] || "-", alignment: "left" },
    ];
  });

  // สร้าง Helper ลดความยาวของการพิมพ์ total(data, "...") และคำนวณยอดรวมต่างๆ ไว้ก่อน 1 ครั้ง
  const t = (key) => total(data, key);
  const totalOther = t("other_income") + t("fire_cost") + t("cable_cost");
  const totalDebt = t("add_debt") - t("reduce_debt");
  const totalFinal = t("water_bill") + t("equipment_maintenance_fee") + t("common_expenses") + t("waste_cost") + totalOther + totalDebt + t("meter_connect_cost") + t("late_payment") + t("change_satang");

  const docDefinition = {
    content: [
      { text: "รายงานรับชำระประจำวัน", alignment: "center", fontSize: 18, bold: true },
      { text: getStorage("project_name"), alignment: "center", fontSize: 18, bold: true },
      { text: "ประจำเดือน " + format_date(start_date, "mmmm yyyy"), alignment: "center", fontSize: 18, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 2,
          widths: ["8.13%", "8.13%", "8.88%", "4.88%", "4.88%", "4.88%", "4.38%", "5.88%", "4.88%", "4.88%", "4.88%", "5.38%", "3.88%", "6.38%", "4.38%", "4.88%", "9.88%"],
          body: [
            [{ text: "เลขที่ใบเสร็จรับเงิน", colSpan: 2, alignment: "center" }, "", { text: "เลขที่เอกสารปิดงาน", rowSpan: 2, alignment: "center" }, { text: "ปิดงาน ประจำวันที่", rowSpan: 2, alignment: "center" }, { text: "ค่าน้ำประปา", rowSpan: 2, alignment: "center" }, { text: "ค่ารักษา อุปกรณ์น้ำ", rowSpan: 2, alignment: "center" }, { text: "ค่าใช้จ่าย ส่วนกลาง", rowSpan: 2, alignment: "center" }, { text: "ค่าจัดเก็บขยะ", rowSpan: 2, alignment: "center" }, { text: "รายรับอื่นๆ", rowSpan: 2, alignment: "center" }, { text: "เพิ่ม/ลดหนี้", rowSpan: 2, alignment: "center" }, { text: "ค่าต่อกลับ มิเตอร์", rowSpan: 2, alignment: "center" }, { text: "ค่าปรับชำระ ล่าช้า", rowSpan: 2, alignment: "center" }, { text: "ปรับเศษ", rowSpan: 2, alignment: "center" }, { text: "รวมเป็นเงิน", colSpan: 2, alignment: "center" }, "", { text: "วันที่นำเงินฝากธนาคาร", rowSpan: 2, alignment: "center" }, { text: "นำฝากบัญชี", rowSpan: 2, alignment: "center" }],
            [{ text: "เลขที่เริ่มต้น", alignment: "center" }, { text: "เลขที่สุดท้าย", alignment: "center" }, "", "", "", "", "", "", "", "", "", "", "", { text: "จัดเก็บ-นำฝาก", alignment: "center" }, { text: "หมายเหตุ", alignment: "center" }, "", ""],
            ...array,
            [
              { text: "" }, { text: "" }, { text: "รวมเป็นเงิน" }, { text: "" },
              { text: toFixed(t("water_bill")), alignment: "center" },
              { text: toFixed(t("equipment_maintenance_fee")), alignment: "center" },
              { text: toFixed(t("common_expenses")), alignment: "center" },
              { text: toFixed(t("waste_cost")), alignment: "center" },
              { text: toFixed(totalOther), alignment: "center" },
              { text: toFixed(totalDebt), alignment: "center" },
              { text: toFixed(t("meter_connect_cost")), alignment: "center" },
              { text: toFixed(t("late_payment")), alignment: "center" },
              { text: toFixed(t("change_satang")), alignment: "center" },
              { text: toFixed(totalFinal), alignment: "center" },
              { text: "" }, { text: "" }, { text: "" },
            ],
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 9, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "landscape",
  };
  
  const textDocDefinition = await replaceText(docDefinition);
  openPdf(textDocDefinition, "รายชื่อลูกค้าที่ยังไม่โอนกรรมสิทธิ์ห้องชุด บันทึกโอนถึง วันที่ " + new Date().toISOString() + ".pdf");
}

export { report_remittance_1 };